export default function injectScript(url, uniqueId, callback) {
  var _injectionPoint$paren;
  if (Object.prototype.toString.call(callback) !== '[object Function]') {
    callback = () => null;
  }
  if (document.getElementById(uniqueId)) {
    return callback(null, true);
  }
  const injectionPoint = document.getElementsByTagName('script')[0];
  const jsNode = document.createElement('script');
  jsNode.id = uniqueId;
  injectionPoint === null || injectionPoint === void 0 ? void 0 : (_injectionPoint$paren = injectionPoint.parentNode) === null || _injectionPoint$paren === void 0 ? void 0 : _injectionPoint$paren.insertBefore(jsNode, injectionPoint);
  jsNode.onload = callback.bind(null, null, false);
  jsNode.src = url;
}